<template>
  <div class="admin">
    <el-container>
      <el-aside width="300px">
        <div class="side-panel">
          <el-menu
            :default-active="activeMenu"
            background-color="#fafafa"
            text-color="#666"
            active-text-color="#012c63"
            @select="handleSelect"
          >
            <el-menu-item v-for="m in menus" v-bind:key="m.index" :index="m.index">
              <i class="el-icon-menu"></i>
              <span>{{ m.title }}</span>
            </el-menu-item>
          </el-menu>
        </div>
      </el-aside>
      <el-main>
        <router-view/>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Admin",
  data() {
    return {
      menus: [],
    };
  },
  computed: {
    activeMenu: function() {
      let m = this.$route.path
        .split("/")
        .slice(2, 3)
        .join("");
      return m;
    }
  },
  created() {
    axios.get("/api/accounts/admin/menus/").then(response=>{
      this.menus = response.data;
    })
  },
  methods: {
    handleSelect(key) {
      this.$router.push({ name: key  });
    }
  }
};
</script>

<style scoped>
/* Transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.fade-leave-to {
  display: none;
}

/* scoped */
.admin {
  height: 100%;
  min-height: 100%;
  overflow: auto;
}

.el-aside {
  overflow-x: hidden;
}
.el-container {
  height: 100%;
  min-height: 100%;
}

.admin .el-main {
  padding: 16px !important;
}
/* 設定, 管理者メニュー用のサイドメニュー */
.side-panel {
  height: 100%;
  min-height: 100%;
  overflow: hidden;
}

.side-panel .el-menu {
  height: 100%;
  min-height: 100%;
}

.side-panel .el-menu-item {
  /*font-size: 14px;*/
  height: 42px;
  line-height: 42px;
}

.side-panel li {
  padding-left: 26px !important;
}
.side-panel li.is-active {
  padding-left: 20px !important;
  border-left: 6px solid #012c63;
  background-color: #e8e8e8 !important;
  font-weight: bold;
}
</style>

